// Returns team billing path depending on whether a subscription
// exists. Requires team to have id and hasSubscription properties.
export const getTeamBillingPath = (team) =>
  `/app/team/${team.id}/${
    team.hasSubscription
      ? `billing?continueUrl=${window.location.href}`
      : `onboard?backPath=${window.location.pathname}`
  }`;
